import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { FormControl, Validators, UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as  _ from 'lodash';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { OrderService } from '@app/_services';
import { ToastrService } from 'ngx-toastr';
import { TranslateHelper } from '@app/_helpers';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { NgFor, NgIf } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-cancel-reason-dialog',
    templateUrl: './cancel-order-dialog.component.html',
    styleUrls: ['./cancel-order-dialog.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [MatDialogTitle, FlexModule, MatDividerModule, MatDialogContent, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, NgFor, MatOptionModule, NgIf, MatInputModule, MatDialogActions, MatButtonModule, TranslateModule]
})
export class CancelReasonsDialogComponent implements OnInit {

    constructor(private dialogref: MatDialogRef<any>, private fb: UntypedFormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private toastr: ToastrService,
        private orderService: OrderService,
        public translate: TranslateService,
        public translateHelper: TranslateHelper) { }

    form = this.fb.group({
        _id: [this.data.orderId],
        reason : [null, [Validators.required]],
        other : [{value: '', disabled: true}, [ Validators.required]],
        note : ['',],
    });

    reasons = [];


    ngOnInit(): void {
        this.orderService.getCancelReasonsList().subscribe((res)=>{
            if (res.code == 200) this.reasons = res.data || [];
            this.reasons.push({en:"Other", ar: "أخرى"});
        });
    }

    submit() {
        if (this.form.invalid) {
            this.toastr.error(this.translateHelper.getTranslation("please_write_reason"));
            return;
        }

        let formValue = _.cloneDeep(this.form.value);

        if (formValue.reason == 'Other' || formValue.reason == 'أخرى') formValue.reason = formValue.other;

        this.dialogref.close(formValue);
    }

    onChange(event) {
        if (event.value == 'Other' || event.value == 'أخرى') this.form.get('other').enable();
        else {
        this.form.get('other').disable();

        }
    }

}
